var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.523,
    height: 31.455,
    viewBox: "0 0 27.523 31.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(8.915 9.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M53.553,19l.87,2.7a2.214,2.214,0,0,1-1.966,2.2,2,2,0,0,1-.246.015A2.209,2.209,0,0,1,50,21.7V19Z",
    transform: "translate(-32.306 -19)",
    fill: "#f6f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M18.423,21.123v.58A2.212,2.212,0,1,1,14,21.7V19h3.16A16.971,16.971,0,0,0,18.423,21.123Z",
    transform: "translate(-14 -19)",
    fill: "#f6f0f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M50.284,13.915H43.57a5.879,5.879,0,0,0,.7-2.457A6.393,6.393,0,0,0,43.781,9h4.2a.987.987,0,0,1,.939.683Z",
    transform: "translate(-20.122 -4.577)",
    fill: "#f75473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M50.284,13.915H43.57a5.879,5.879,0,0,0,.7-2.457A6.393,6.393,0,0,0,43.781,9H46.16a5.9,5.9,0,0,1,.079.983,3.985,3.985,0,0,1-.14.993,1.191,1.191,0,0,0,1.173,1.464h2.536Z",
    transform: "translate(-20.122 -4.577)",
    fill: "#db4063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M11.457,23.9a2.212,2.212,0,0,0,4.423,0v-.58A41.265,41.265,0,0,0,20.3,28.569a41.265,41.265,0,0,0,4.423-5.249v.58a2.212,2.212,0,0,0,4.423,0,2.209,2.209,0,0,0,2.212,2.212,2,2,0,0,0,.246-.015V41.839a.986.986,0,0,1-.983.983H26.2V33.484h1.474a.493.493,0,0,0,.491-.491V31.027a.493.493,0,0,0-.491-.491H12.932a.493.493,0,0,0-.491.491v1.966a.493.493,0,0,0,.491.491h1.474v9.338H9.983A.986.986,0,0,1,9,41.839V26.1a2,2,0,0,0,.246.015A2.215,2.215,0,0,0,11.457,23.9Z",
    transform: "translate(-2.543 -11.859)",
    fill: "#f6f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M31.363,26.112A2.209,2.209,0,0,1,29.151,23.9a2.212,2.212,0,1,1-4.423,0v-.58A41.265,41.265,0,0,1,20.3,28.569a41.265,41.265,0,0,1-4.423-5.249v.58a2.212,2.212,0,1,1-4.423,0,2.215,2.215,0,0,1-2.212,2.212A2,2,0,0,1,9,26.1v1.817c3.6-.328,7.209-.656,10.813,1.638,2.457,1.474,4.423-2.949,6.881-1.474,4.767,3.064,3.4,8.96,2.766,14.745h1.166a.986.986,0,0,0,.983-.983V26.1a2,2,0,0,1-.246.015Z",
    transform: "translate(-2.543 -11.859)",
    fill: "#d3bccd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M36.605,2.966A6.35,6.35,0,0,0,32,1h8.847a.986.986,0,0,1,.983.983V4.932H37.9A6.3,6.3,0,0,0,36.605,2.966Z",
    transform: "translate(-14.238 -0.509)",
    fill: "#69c9b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M45.423,19v2.7A2.212,2.212,0,1,1,41,21.7v-.58A16.97,16.97,0,0,0,42.263,19Z",
    transform: "translate(-18.815 -9.662)",
    fill: "#f75473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M31.728,38.491v1.966a.493.493,0,0,1-.491.491H16.491A.493.493,0,0,1,16,40.457V38.491A.493.493,0,0,1,16.491,38H31.236A.493.493,0,0,1,31.728,38.491Z",
    transform: "translate(-6.102 -19.324)",
    fill: "#6a6e73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M31.287,4.932a6.393,6.393,0,0,1,.491,2.457,5.879,5.879,0,0,1-.7,2.457,16.97,16.97,0,0,1-1.263,2.123,41.265,41.265,0,0,1-4.423,5.249,41.265,41.265,0,0,1-4.423-5.249A16.97,16.97,0,0,1,19.7,9.847,5.879,5.879,0,0,1,19,7.389a6.393,6.393,0,0,1,.491-2.457,6.394,6.394,0,0,1,11.8,0Z",
    transform: "translate(-7.628 -0.509)",
    fill: "#f75473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M32,44h5.9v9.338H32Z",
    transform: "translate(-14.238 -22.375)",
    fill: "#4e71d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M37.9,51.372v1.966H32V44h1.474v5.5a1.875,1.875,0,0,0,1.875,1.875Z",
    transform: "translate(-14.238 -22.375)",
    fill: "#3667e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(14 3)",
    fill: "#ffca88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M32.277,10.837a3.442,3.442,0,0,1-6.5,1.583,3.444,3.444,0,0,0,4.64-4.64A3.438,3.438,0,0,1,32.277,10.837Z",
    transform: "translate(-11.075 -3.956)",
    fill: "#ffb243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M20,44h5.9v9.338H20Z",
    transform: "translate(-8.136 -22.375)",
    fill: "#4e71d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M17.225,2.966a6.3,6.3,0,0,0-1.293,1.966H12V1.983A.986.986,0,0,1,12.983,1H21.83A6.35,6.35,0,0,0,17.225,2.966Z",
    transform: "translate(-4.068 -0.509)",
    fill: "#69c9b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M36.658,1H32a6.412,6.412,0,0,1,5.9,3.932H41.83V3.607C39.946,3.645,38.274,2.387,36.658,1Z",
    transform: "translate(-14.238 -0.509)",
    fill: "#14ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M17.275,1A6.878,6.878,0,0,1,12,3.686V4.932h3.932A6.412,6.412,0,0,1,21.83,1Z",
    transform: "translate(-4.068 -0.509)",
    fill: "#14ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M13.484,13.915H6.77L8.136,9.683A.987.987,0,0,1,9.075,9h4.2a6.393,6.393,0,0,0-.491,2.457A5.879,5.879,0,0,0,13.484,13.915Z",
    transform: "translate(-1.409 -4.577)",
    fill: "#f75473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M12.781,11.457A6.393,6.393,0,0,1,13.272,9H11.646c.107,2.513-1.954,3.476-4.569,3.963l-.307.952h6.714A5.879,5.879,0,0,1,12.781,11.457Z",
    transform: "translate(-1.409 -4.577)",
    fill: "#db4063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M9.423,19v2.7a2.215,2.215,0,0,1-2.212,2.212,2,2,0,0,1-.246-.015A2.21,2.21,0,0,1,5,21.7L5.87,19Z",
    transform: "translate(-0.509 -9.662)",
    fill: "#f75473"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(4 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M29.263,4.954a1.476,1.476,0,0,0-1.18-1V1.474A1.476,1.476,0,0,0,26.608,0H8.915A1.476,1.476,0,0,0,7.44,1.474V3.95A1.477,1.477,0,0,0,6.26,4.956L4.024,11.891A.507.507,0,0,0,4,12.041a2.707,2.707,0,0,0,1.966,2.6V29.981A1.476,1.476,0,0,0,7.44,31.455H28.083a1.476,1.476,0,0,0,1.474-1.474V14.631a2.63,2.63,0,0,0,1.171-.677,2.665,2.665,0,0,0,.8-1.912.507.507,0,0,0-.024-.151Zm-.935.3,1.157,3.59h-3.86a.491.491,0,0,0,0,.983h.491v2.212a1.723,1.723,0,0,1-1.72,1.72,1.722,1.722,0,0,1-1.72-1.72v-.434a9.626,9.626,0,0,0,1.966-4.726,6.84,6.84,0,0,0-.29-1.966h3.5a.494.494,0,0,1,.471.342ZM11.864,6.881a5.9,5.9,0,0,1,11.8,0c0,2.559-3.976,7.163-5.9,9.132-1.922-1.969-5.9-6.573-5.9-9.132ZM26.608.983a.492.492,0,0,1,.491.491V3.932H23.969a6.909,6.909,0,0,0-.569-.983h2.225a.491.491,0,0,0,0-.983H22.568a6.929,6.929,0,0,0-1.28-.983ZM8.915.983h5.321a6.913,6.913,0,0,0-1.28.983H9.9a.491.491,0,1,0,0,.983h2.225a6.862,6.862,0,0,0-.569.983H8.423V1.474A.492.492,0,0,1,8.915.983ZM7.2,5.258a.5.5,0,0,1,.471-.344h3.5a6.84,6.84,0,0,0-.29,1.966,9.626,9.626,0,0,0,1.966,4.726v.434a1.723,1.723,0,0,1-1.72,1.72,1.722,1.722,0,0,1-1.72-1.72V9.83H9.9a.491.491,0,0,0,0-.983H6.038ZM4.984,12.114,5.721,9.83h2.7v2.212a1.723,1.723,0,0,1-1.72,1.72,1.722,1.722,0,0,1-1.719-1.648Zm5.4,9.02V19.168H25.134v1.966Zm6.881.983V23.1a.491.491,0,0,0,.983,0v-.983h4.915v8.355H18.253V25.066a.491.491,0,1,0-.983,0v5.406H12.355V22.117Zm10.813,8.355H24.151V22.117h.983a.984.984,0,0,0,.983-.983V19.168a.984.984,0,0,0-.983-.983H10.389a.984.984,0,0,0-.983.983v1.966a.984.984,0,0,0,.983.983h.983v8.355H7.44a.492.492,0,0,1-.491-.491V14.721A2.7,2.7,0,0,0,8.916,13.6a2.7,2.7,0,0,0,2.211,1.149,2.676,2.676,0,0,0,2.58-1.934,43,43,0,0,0,3.71,4.25.491.491,0,0,0,.69,0,43.032,43.032,0,0,0,3.7-4.24A2.707,2.707,0,0,0,24.4,14.745,2.735,2.735,0,0,0,26.609,13.6a2.7,2.7,0,0,0,1.965,1.134V29.981A.492.492,0,0,1,28.083,30.472Zm1.95-17.213a1.691,1.691,0,0,1-1.213.5,1.722,1.722,0,0,1-1.72-1.72V9.83h2.7l.737,2.284a1.692,1.692,0,0,1-.506,1.146Z",
    transform: "translate(-4 0)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M22.144,52.788a.491.491,0,0,0,.695,0l2.949-2.949a.491.491,0,1,0-.695-.695l-2.949,2.949A.491.491,0,0,0,22.144,52.788Z",
    transform: "translate(-13.153 -24.917)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M22.491,49.966a.49.49,0,0,0,.347-.144l.983-.983a.491.491,0,0,0-.695-.695l-.983.983a.491.491,0,0,0,.347.839Z",
    transform: "translate(-13.153 -24.409)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M27.127,54.144l-.983.983a.491.491,0,1,0,.695.695l.983-.983a.491.491,0,0,0-.695-.695Z",
    transform: "translate(-15.187 -27.46)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M34.491,51.932a.49.49,0,0,0,.347-.144l2.949-2.949a.491.491,0,1,0-.695-.695l-2.949,2.949a.491.491,0,0,0,.347.839Z",
    transform: "translate(-19.255 -24.409)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M34.491,49.474a.49.49,0,0,0,.347-.144l.491-.491a.491.491,0,0,0-.695-.695l-.491.491a.491.491,0,0,0,.347.839Z",
    transform: "translate(-19.255 -24.409)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M39.127,53.144l-.983.983a.491.491,0,1,0,.695.695l.983-.983a.491.491,0,0,0-.695-.695Z",
    transform: "translate(-21.289 -26.951)",
    fill: "#352727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M31.864,9.932a3.932,3.932,0,1,0-3.932,3.932A3.936,3.936,0,0,0,31.864,9.932Zm-6.881,0a2.949,2.949,0,1,1,2.949,2.949A2.952,2.952,0,0,1,24.983,9.932Z",
    transform: "translate(-14.17 -3.051)",
    fill: "#352727"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.252b2b49c8186c9b128fc61079d3b1f5.svg";
export { ForwardRef as ReactComponent };